import { apiService } from './api'
import { adminAuthService } from './adminAuth'

/**
 * 용량 관리 API.
 *
 * 화면에서 fetch('/admin/capacity/...') 를 직접 부르면 운영에서 백엔드에
 * 닿지 않는다. 경로는 공용 axios 클라이언트가 정한다.
 */

function authConfig() {
  const token = adminAuthService.getToken()
  if (!token) {
    throw new Error('No admin token available')
  }
  return { headers: { Authorization: `Bearer ${token}` } }
}

function unwrap<T>(body: any, pick: (body: any) => T, fallback: string): T {
  if (!body?.success) {
    throw new Error(body?.message || fallback)
  }
  return pick(body)
}

export const adminCapacityApi = {
  /** 현재 용량. database·disk·growth 를 그대로 돌려준다 */
  async current(): Promise<Record<string, any>> {
    const { data } = await apiService.client.get(
      '/admin/capacity/current',
      authConfig()
    )
    return unwrap(data, b => b, '용량 데이터 조회 실패')
  },

  async collection(
    name: string,
    page: number,
    limit: number = 10
  ): Promise<Record<string, any>> {
    const { data } = await apiService.client.get(
      `/admin/capacity/collection/${encodeURIComponent(name)}`,
      { ...authConfig(), params: { page, limit } }
    )
    return unwrap(data, b => b, '컬렉션 데이터 조회 실패')
  },

  async clearCollection(name: string): Promise<number> {
    const { data } = await apiService.client.delete(
      `/admin/capacity/collection/${encodeURIComponent(name)}`,
      authConfig()
    )
    return unwrap(data, b => b.deletedCount ?? 0, '컬렉션 초기화 실패')
  },
}

export default adminCapacityApi
